import { makeClassName } from '@siteless/util';
import { BaseContainerComponentPropsType } from '../../util/types';

const Page = ({ className, children }: BaseContainerComponentPropsType) => (
  <div className={makeClassName('Page', className)}>{children}</div>
);

Page.Body = ({ className, children }: BaseContainerComponentPropsType) => (
  <div className={makeClassName('Page__body p-8 pb-28', className)}>
    {children}
  </div>
);

Page.Bar = ({
  className,
  children,
  fullScreen,
}: BaseContainerComponentPropsType & {
  fullScreen?: boolean;
}) => (
  <div
    className={makeClassName(
      'Page__bar',
      !fullScreen && 'sm:mx-auto sm:w-[500px]',
      className,
    )}
  >
    {children}
  </div>
);

Page.BottomActions = ({
  className,
  children,
}: BaseContainerComponentPropsType) => (
  <div className={makeClassName('Page__bottom-actions', className)}>
    {children}
  </div>
);

export default Page;
